// import React from "react";
// import styles from "./Footer.module.css";
// import { FaHome, FaArrowUp } from "react-icons/fa";
// import { IoIosFootball } from "react-icons/io";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   return (
//     <footer className={styles.footer}>
//       <Link to="/shortz" className={styles.circle}>
//         <div className={styles.arrow}>↑</div>
//         <div className={styles.label}>Shortz</div>
//       </Link>
//        <Link to="/matches" className={styles.sideLink}>
//         <IoIosFootball className={styles.icon} />
//         <span className={styles.linkText}>Matches</span>
//       </Link>
//     </footer>
//   );
// };

// export default Footer;
import React from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";
import { FaHome, FaArrowUp } from "react-icons/fa";
import { IoIosFootball } from "react-icons/io";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Link to="/" className={styles.sideLink}>
        <FaHome className={styles.icon} />
        <span className={styles.linkText}>Home</span>
      </Link>
      <Link to="/shortz" className={styles.circle}>
        <FaArrowUp className={styles.arrow} />
        <div className={styles.label}>Shortz</div>
      </Link>
      <Link to="/matches" className={styles.sideLink}>
        <IoIosFootball className={styles.icon} />
        <span className={styles.linkText}>Matches</span>
      </Link>
    </footer>
  );
};

export default Footer;